import axios from "axios";

const api = axios.create({
  baseURL: "http://localhost:6060/api", // dein Spring Boot Backend
  withCredentials: true, // wichtig, damit Cookies für Session-Login gesendet werden
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
